import { House } from "lucide-react";
import { useTranslation } from "react-i18next";

import { LinkAction } from "../components/Screen.js";

/**
 * The 404.
 *
 * It rendered `components/Placeholder` until the translation sweep, which was
 * wrong in a way nobody had noticed: that component is the phase-0 scaffold, so
 * a real dead link told a real player *"Not built yet — —"*. Its own doc comment
 * asked to be deleted once nothing imported it, and this was the last importer.
 *
 * The two ways somebody arrives here are a mistyped party code and a link that
 * has outlived its party, so the way out is the front door — where the code box
 * is — rather than a bare apology.
 */
export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-3 p-8 text-center">
      <p className="text-xs uppercase tracking-[0.2em] text-flash-500">{t("app.name")}</p>
      <h1 className="text-2xl font-semibold">{t("notFound.title")}</h1>
      <p className="max-w-prose text-sm text-white/60">{t("notFound.body")}</p>
      <div className="mt-4 w-full max-w-xs">
        <LinkAction to="/" icon={House} accent>
          {t("notFound.action")}
        </LinkAction>
      </div>
    </main>
  );
}
